import React from 'react';
import type { RedcatIconProps } from './RedcatIcon';
import { REDCAT_ICON_DEFAULT_COLOR, REDCAT_ICON_DEFAULT_SIZE } from './RedcatIcon';

const RedcatPhoneMessageIcon = ({
  size = REDCAT_ICON_DEFAULT_SIZE,
  color = REDCAT_ICON_DEFAULT_COLOR,
}: RedcatIconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 16V20C15 20.2652 14.8946 20.5196 14.7071 20.7071C14.5196 20.8946 14.2652 21 14 21H6C5.73478 21 5.48043 20.8946 5.29289 20.7071C5.10536 20.5196 5 20.2652 5 20V6C5 5.73478 5.10536 5.48043 5.29289 5.29289C5.48043 5.10536 5.73478 5 6 5H8M10 18V18.01M11 3H21V11H18L14 13V11H11V3Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default RedcatPhoneMessageIcon;
